
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 16.17l-3.465-3.465A1 1 0 104.12 14.12l4.173 4.173a1 1 0 001.414 0L20.295 7.705a.997.997 0 00-1.41-1.41L9 16.17z","fill":"#282E3E"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.123 12.703a1 1 0 011.412.002L9 16.17l9.885-9.876a.997.997 0 011.41 1.411L9.707 18.293a1 1 0 01-1.414 0L4.12 14.12a1 1 0 01.003-1.417zM9 15.463l9.532-9.522a1.497 1.497 0 012.116 2.118L9.708 19a1 1 0 01-1.415 0l-4.527-4.526A1.5 1.5 0 015.89 12.35L9 15.463z","fill":"#282E3E"}})])
          )
        }
      }
    